/**
 * Beats of a hero moment that live outside the VFX module and outside `vfx`'s files, called by name so the Phase 2
 * agents meet in the middle (PHASE2_BRIEF "Shared hooks"). Each slot is null until the owner's side is wired; every
 * caller uses optional chaining, so a missing side is simply a quieter moment, never an error.
 *
 *   FxHooks.screenFlash   ← ui:   `ScreenFlash.flash(color, peak, ms)` — the DOM white/violet flash (opacity only)
 *   FxHooks.exposurePunch ← look: `PostFx.exposurePunch(gain, ms)`      — a brief exposure lift on the whole frame
 *
 * Wiring at merge, e.g. in main/scene setup: `FxHooks.screenFlash = (c, p, ms) => ScreenFlash.flash(c, p, ms);`
 */
export const FxHooks: {
  screenFlash: ((color: string, peak: number, ms: number) => void) | null;
  exposurePunch: ((gain: number, ms: number) => void) | null;
} = { screenFlash: null, exposurePunch: null };

/** The fortress strike's beats (vfx side of the numbers, so they are tuned in one place). */
export const StrikeBeats = {
  /** StrikeLight at the target: violet-white, intensity 40, range 6 m, fading over 0.18 s. */
  light: { colour: 0xd9c8ff, intensity: 40, range: 6, seconds: 0.18, lift: 0.8 },
  exposure: { gain: 1.5, ms: 160 },
  flash: { color: "#efe6ff", peak: 0.22, ms: 140 },
} as const;
